import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
// Mutable module scoped variable to hold the most-recent UserState.
// This is used as the initial user state for new hook invocations and is kept up-to-date during calls to publish()
let _userState = {
    userSignedIn: false,
};
const _subscribers = new Set();
const _subscribe = (cb) => {
    _subscribers.add(cb);
    return () => {
        _subscribers.delete(cb);
    };
};
const publish = (nextUserState) => {
    // !! This function should not be called during server render !!
    // Mutating the userState is not correct during a server-render as it could lead to inconsistent
    // component state and render results.
    if (window === undefined || window.document === undefined || window.document.cookie === undefined) {
        throw Error('Modifying UserState is not supported during the server render. Did you forget to wrap an update inside useEffect()?');
    }
    _userState = nextUserState;
    _subscribers.forEach((cb) => cb(nextUserState));
};
const useUserState = () => {
    const [user, setUser] = useState(_userState);
    useEffect(() => {
        const _unsubscribe = _subscribe(setUser);
        if (_userState.userSignedIn !== !!Cookies.get('ursid')) {
            // sync module state with cookies
            publish(Object.assign(Object.assign({}, _userState), { userSignedIn: !!Cookies.get('ursid') }));
        }
        else if (user.userSignedIn !== _userState.userSignedIn) {
            // _or_ sync component state with module state
            setUser(Object.assign({}, _userState));
        }
        return () => _unsubscribe();
    }, [_subscribe, publish, setUser]);
    return [user, publish];
};
export { useUserState };
